module.exports = __webpack_public_path__ + "c09f40c7cce9223b2e52648bb2fba6b9.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/gevonden_rustig.mp3
// module id = 92
// module chunks = 0